export default {
  api: {
    endpoint: process.env.REACT_APP_API_ENDPOINT || 'http://localhost:3001',
    prefix: process.env.REACT_APP_API_PREFIX || '',
  },
};
